const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: The Three Elementary Mechanical Elements ──────────────
function DiagramThreeElements() {
  const W = 900, H = 320;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Three Elementary Mechanical Elements — Mass, Spring, Damper</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowBlue" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#2E75B6"/>
          </marker>
          <marker id="arrowRed" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="arrowGreen" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#27ae60"/>
          </marker>
        </defs>

        {/* ── Panel 1: Mass ─────────────────────────────────────────── */}
        <rect x={10} y={10} width={273} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={146} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Mass (m)</text>

        {/* Ground line */}
        <line x1={40} y1={230} x2={252} y2={230} stroke="#555" strokeWidth="2"/>
        {[40,60,80,100,120,140,160,180,200,220,240].map(x => (
          <line key={x} x1={x} y1={230} x2={x-10} y2={248} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Mass block */}
        <rect x={90} y={155} width={110} height={70} rx={5} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={145} y={195} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">m</text>

        {/* Force arrow */}
        <line x1={200} y1={190} x2={252} y2={190} stroke="#c0392b" strokeWidth="3" markerEnd="url(#arrowRed)"/>
        <text x={256} y={195} fontSize="13" fill="#c0392b" fontWeight="700">F</text>

        {/* Acceleration arrow */}
        <line x1={90} y1={175} x2={40} y2={175} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#arrowBlue)"/>
        <text x={18} y={170} fontSize="12" fill="#2E75B6" fontWeight="700">a</text>

        {/* Formula box */}
        <rect x={16} y={248} width={261} height={52} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={264} fontSize="13" fill="#7B0D0D" fontWeight="700">F = m·a = m·ẍ</text>
        <text x={22} y={281} fontSize="11" fill="#444">Stores kinetic energy: T = ½mv²</text>
        <text x={22} y={296} fontSize="11" fill="#444">Resists change in velocity (inertia)</text>

        {/* ── Panel 2: Spring ───────────────────────────────────────── */}
        <rect x={293} y={10} width={273} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={429} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Spring (k)</text>

        {/* Wall */}
        <rect x={305} y={100} width={12} height={130} rx={0} fill="#888"/>
        {[100,116,132,148,164,180,196,212,228].map(y => (
          <line key={y} x1={305} y1={y} x2={290} y2={y+14} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring coil */}
        {(() => {
          const x0 = 317, x1 = 520, y = 165, coils = 9, cW = (x1-x0)/coils;
          const pts = [[x0, y]];
          for (let i = 0; i < coils; i++) {
            pts.push([x0 + i*cW + cW*0.25, y - 22]);
            pts.push([x0 + i*cW + cW*0.75, y + 22]);
          }
          pts.push([x1, y]);
          const d = pts.map((p,i) => `${i===0?'M':'L'} ${p[0]},${p[1]}`).join(' ');
          return <path d={d} fill="none" stroke="#27ae60" strokeWidth="2.5"/>;
        })()}

        {/* Block */}
        <rect x={520} y={130} width={50} height={70} rx={4} fill="#27ae60" stroke="#1e8449" strokeWidth="2"/>
        <text x={545} y={170} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">x</text>

        {/* Force arrow */}
        <line x1={570} y1={165} x2={548} y2={165} stroke="#c0392b" strokeWidth="3" markerEnd="url(#arrowRed)"/>
        <text x={554} y={155} fontSize="12" fill="#c0392b" fontWeight="700">F</text>

        {/* x label */}
        <line x1={317} y1={220} x2={520} y2={220} stroke="#555" strokeWidth="1" strokeDasharray="4"/>
        <text x={418} y={215} textAnchor="middle" fontSize="12" fill="#555">displacement x</text>

        <rect x={299} y={248} width={261} height={52} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={305} y={264} fontSize="13" fill="#7B0D0D" fontWeight="700">F = k·x</text>
        <text x={305} y={281} fontSize="11" fill="#444">Stores potential energy: V = ½kx²</text>
        <text x={305} y={296} fontSize="11" fill="#444">Restores to equilibrium (elastic)</text>

        {/* ── Panel 3: Damper ───────────────────────────────────────── */}
        <rect x={576} y={10} width={314} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={733} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Viscous Damper (c)</text>

        {/* Wall */}
        <rect x={588} y={100} width={12} height={130} rx={0} fill="#888"/>
        {[100,116,132,148,164,180,196,212,228].map(y => (
          <line key={y} x1={588} y1={y} x2={573} y2={y+14} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Damper outer cylinder */}
        <rect x={600} y={148} width={110} height={36} rx={5} fill="#ddd" stroke="#999" strokeWidth="2"/>
        {/* Damper fluid fill */}
        <rect x={602} y={150} width={106} height={32} rx={4} fill="#b3cde3" opacity="0.7"/>
        {/* Damper piston rod */}
        <rect x={710} y={159} width={70} height={14} rx={3} fill="#888" stroke="#555" strokeWidth="1.5"/>
        {/* Piston */}
        <rect x={700} y={148} width={12} height={36} rx={2} fill="#555"/>

        {/* Block on end of piston */}
        <rect x={780} y={140} width={50} height={52} rx={4} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
        <text x={805} y={170} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">ẋ</text>

        {/* Velocity arrow */}
        <line x1={830} y1={166} x2={878} y2={166} stroke="#c0392b" strokeWidth="3" markerEnd="url(#arrowRed)"/>
        <text x={882} y={171} fontSize="12" fill="#c0392b" fontWeight="700">v</text>

        {/* Damping waves / heat symbol */}
        {[620,640,660,680].map(x => (
          <path key={x} d={`M ${x},145 Q ${x+8},135 ${x+16},145`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.6"/>
        ))}
        <text x={655} y={130} textAnchor="middle" fontSize="11" fill="#c0392b" fontStyle="italic">energy dissipated</text>

        <rect x={582} y={248} width={302} height={52} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1"/>
        <text x={588} y={264} fontSize="13" fill="#7B0D0D" fontWeight="700">F = c·ẋ = c·v</text>
        <text x={588} y={281} fontSize="11" fill="#444">Dissipates energy as heat (dashpot)</text>
        <text x={588} y={296} fontSize="11" fill="#444">Force proportional to velocity, not position</text>
      </svg>
      <div style={S.dCaption}>
        The three elementary elements of mechanical system dynamics. Mass stores kinetic energy and resists acceleration. Springs store potential energy and provide restoring forces. Dampers (dashpots) dissipate energy through viscous resistance proportional to velocity.
      </div>
    </div>
  );
}

// ── Diagram 2: Mass-Spring-Damper System ────────────────────────────
function DiagramMSD() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Mass-Spring-Damper (MSD) System — The Canonical 2nd-Order Model</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arr2" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="arr2b" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#2E75B6"/>
          </marker>
        </defs>

        {/* ── Left: physical diagram ───────────────────────────── */}
        <rect x={10} y={10} width={460} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={240} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Physical Setup</text>

        {/* Ground */}
        <line x1={30} y1={290} x2={460} y2={290} stroke="#555" strokeWidth="2"/>
        {[30,55,80,105,130,155,180,205,230,255,280,305,330,355,380,405,430,455].map(x => (
          <line key={x} x1={x} y1={290} x2={x-12} y2={308} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Wall */}
        <rect x={30} y={60} width={12} height={230} fill="#888"/>
        {[60,80,100,120,140,160,180,200,220,240,260,280].map(y => (
          <line key={y} x1={30} y1={y} x2={16} y2={y+18} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring (top) */}
        {(() => {
          const x0 = 42, x1 = 220, y = 130, coils = 10, cW = (x1-x0)/coils;
          const pts = [[x0, y]];
          for (let i = 0; i < coils; i++) {
            pts.push([x0 + i*cW + cW*0.25, y - 20]);
            pts.push([x0 + i*cW + cW*0.75, y + 20]);
          }
          pts.push([x1, y]);
          const d = pts.map((p,i) => `${i===0?'M':'L'} ${p[0]},${p[1]}`).join(' ');
          return (
            <>
              <path d={d} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
              <text x={130} y={100} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">k</text>
            </>
          );
        })()}

        {/* Damper (bottom) */}
        {/* Outer cylinder */}
        <rect x={42} y={200} width={130} height={30} rx={4} fill="#ddd" stroke="#999" strokeWidth="2"/>
        <rect x={44} y={202} width={126} height={26} rx={3} fill="#b3cde3" opacity="0.7"/>
        {/* Rod */}
        <rect x={172} y={207} width={50} height={16} rx={2} fill="#888"/>
        {/* Piston */}
        <rect x={163} y={198} width={11} height={34} rx={2} fill="#555"/>
        <text x={100} y={188} textAnchor="middle" fontSize="14" fill="#555" fontWeight="700">c</text>

        {/* Connect spring and damper to mass */}
        <line x1={220} y1={130} x2={240} y2={130} stroke="#27ae60" strokeWidth="2"/>
        <line x1={222} y1={215} x2={240} y2={215} stroke="#555" strokeWidth="2"/>
        <line x1={240} y1={115} x2={240} y2={235} stroke="#999" strokeWidth="2" strokeDasharray="4"/>

        {/* Mass block */}
        <rect x={240} y={160} width={130} height={110} rx={6} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={305} y={220} textAnchor="middle" fontSize="28" fill="#fff" fontWeight="700">m</text>

        {/* Applied force */}
        <line x1={370} y1={215} x2={430} y2={215} stroke="#c0392b" strokeWidth="3.5" markerEnd="url(#arr2)"/>
        <text x={435} y={220} fontSize="15" fill="#c0392b" fontWeight="700">F(t)</text>

        {/* x displacement label */}
        <line x1={260} y1={155} x2={380} y2={155} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5" markerEnd="url(#arr2b)"/>
        <text x={320} y={148} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">x(t)</text>
        <text x={250} y={148} fontSize="12" fill="#2E75B6">0</text>

        {/* Equilibrium line */}
        <line x1={240} y1={290} x2={370} y2={290} stroke="#999" strokeWidth="1" strokeDasharray="3"/>

        {/* ── Right: equations & notes ──────────────────────────── */}
        <rect x={480} y={10} width={410} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={685} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Governing Equation & Parameters</text>

        {/* EOM */}
        <rect x={490} y={44} width={390} height={60} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={685} y={66} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Equation of Motion</text>
        <text x={685} y={90} textAnchor="middle" fontSize="14" fill="#1a1a2e" fontFamily="'Courier New',monospace">mẍ + cẋ + kx = F(t)</text>

        {[
          { y:120, bg:"#eaf3ff", bc:"#2E75B6", label:"m — Mass (kg)", lines:["Coefficient of ẍ (acceleration term)", "Adds inertia; slows system response"] },
          { y:175, bg:"#f0fff4", bc:"#27ae60", label:"k — Spring stiffness (N/m)", lines:["Coefficient of x (displacement term)", "Restoring force; raises natural frequency"] },
          { y:230, bg:"#fff5e6", bc:"#e07b00", label:"c — Damping coeff. (N·s/m)", lines:["Coefficient of ẋ (velocity term)", "Dissipates energy; reduces oscillation"] },
          { y:285, bg:"#f5d0ff", bc:"#9b59b6", label:"ωₙ = √(k/m)   Natural freq. (rad/s)", lines:["Frequency of free undamped oscillation", "Higher k or lower m → faster oscillation"] },
        ].map(({ y, bg, bc, label, lines }) => (
          <g key={y}>
            <rect x={490} y={y} width={390} height={52} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={496} y={y+17} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l, i) => <text key={i} x={496} y={y+32+i*15} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}

        {/* Damping ratio box */}
        <rect x={490} y={342} width={390} height={8} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
      </svg>
      <div style={S.dCaption}>
        The mass-spring-damper system is the fundamental model of mechanical dynamics. Newton's second law gives the equation of motion: mẍ + cẋ + kx = F(t). Every real mechanical system can be modelled as a network of these three elements.
      </div>
    </div>
  );
}

// ── Diagram 3: Translational vs Rotational ──────────────────────────
function DiagramFBD() {
  const W = 900, H = 480;

  const springPath = (x0, x1, y, n = 8) => {
    const cW = (x1 - x0) / n;
    const pts = [[x0, y]];
    for (let i = 0; i < n; i++) {
      pts.push([x0 + i * cW + cW * 0.25, y - 16]);
      pts.push([x0 + i * cW + cW * 0.75, y + 16]);
    }
    pts.push([x1, y]);
    return pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0]},${p[1]}`).join(' ');
  };

  const tableRows = [
    ["Variable","Symbol","Unit"],
    ["Displacement","x","m"],
    ["Velocity","v = ẋ","m/s"],
    ["Acceleration","a = ẍ","m/s²"],
    ["Force","F","N"],
    ["Mass","m","kg"],
    ["Spring const.","k","N/m"],
    ["Damping coeff.","c","N·s/m"],
  ];

  const analogyRows = [
    ["Translational","Rotational"],
    ["Force F (N)","Torque τ (N·m)"],
    ["Mass m (kg)","Inertia J (kg·m²)"],
    ["Displacement x (m)","Angle θ (rad)"],
    ["Velocity ẋ (m/s)","Ang. vel. θ̇ (rad/s)"],
    ["Spring k (N/m)","Tors. spring kᵣ"],
    ["Damper c (N·s/m)","Rot. damper cᵣ"],
    ["mẍ+cẋ+kx = F","Jθ̈+cᵣθ̇+kᵣθ = τ"],
  ];

  const rW = 24, col1 = 110, col2 = 80, col3 = 56;
  const aW1 = 148, aW2 = 168;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Translational vs Rotational Mechanical Systems</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrT" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ── LEFT PANEL ── */}
        <rect x={10} y={10} width={430} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={225} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Translational System</text>

        {tableRows.map(([a, b, c], i) => {
          const ty = 42 + i * rW;
          const bg = i === 0 ? '#c0392b' : (i % 2 === 0 ? '#fff5f5' : '#fff');
          return (
            <g key={i}>
              <rect x={16}           y={ty} width={col1} height={rW} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={16+col1}      y={ty} width={col2} height={rW} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={16+col1+col2} y={ty} width={col3} height={rW} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <text x={20}           y={ty+17} fontSize="11" fill={i===0?'#fff':'#444'} fontWeight={i===0?'700':'400'}>{a}</text>
              <text x={20+col1}      y={ty+17} fontSize="11" fill={i===0?'#fff':'#7B0D0D'} fontFamily="'Courier New',monospace" fontWeight="600">{b}</text>
              <text x={20+col1+col2} y={ty+17} fontSize="11" fill={i===0?'#fff':'#555'}>{c}</text>
            </g>
          );
        })}

        {/* Ground */}
        <line x1={30} y1={430} x2={425} y2={430} stroke="#555" strokeWidth="2"/>
        {[30,52,74,96,118,140,162,184,206,228,250,272,294,316,338,360,382,404].map(x => (
          <line key={x} x1={x} y1={430} x2={x-12} y2={448} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Wall */}
        <rect x={18} y={340} width={12} height={92} fill="#888"/>
        {[340,358,376,394,412].map(y => (
          <line key={y} x1={18} y1={y} x2={6} y2={y+16} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring */}
        <path d={springPath(30, 155, 386, 8)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={92} y={368} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">k</text>

        {/* Mass block */}
        <rect x={155} y={356} width={130} height={70} rx={5} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={220} y={397} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">M</text>

        {/* Wheels */}
        {[180, 260].map(cx => (
          <g key={cx}>
            <circle cx={cx} cy={430} r={14} fill="#888" stroke="#555" strokeWidth="2"/>
            <circle cx={cx} cy={430} r={5}  fill="#fff"/>
          </g>
        ))}

        {/* Force */}
        <line x1={285} y1={391} x2={355} y2={391} stroke="#c0392b" strokeWidth="3" markerEnd="url(#arrT)"/>
        <text x={360} y={396} fontSize="15" fill="#c0392b" fontWeight="700">F</text>

        {/* EOM */}
        <text x={225} y={468} textAnchor="middle" fontSize="12" fill="#555" fontFamily="'Courier New',monospace">mẍ + cẋ + kx = F</text>

        {/* ── RIGHT PANEL ── */}
        <rect x={450} y={10} width={440} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={670} y={34} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Rotational System</text>

        {analogyRows.map(([a, b], i) => {
          const ty = 42 + i * rW;
          const bg = i === 0 ? '#c0392b' : (i % 2 === 0 ? '#fff5f5' : '#fff');
          const mono = i === 7;
          return (
            <g key={i}>
              <rect x={456}     y={ty} width={aW1} height={rW} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={456+aW1} y={ty} width={aW2} height={rW} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <text x={460}     y={ty+17} fontSize={mono?10:11} fill={i===0?'#fff':'#444'} fontWeight={i===0?'700':'400'} fontFamily={mono?"'Courier New',monospace":'inherit'}>{a}</text>
              <text x={460+aW1} y={ty+17} fontSize={mono?10:11} fill={i===0?'#fff':'#7B0D0D'} fontWeight={i===0?'700':'400'} fontFamily={mono?"'Courier New',monospace":'inherit'}>{b}</text>
            </g>
          );
        })}

        {/* Wall for rotational */}
        <rect x={458} y={330} width={12} height={110} fill="#888"/>
        {[330,348,366,384,402,420].map(y => (
          <line key={y} x1={458} y1={y} x2={446} y2={y+16} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Torsional spring waves */}
        {[0,1,2,3].map(i => {
          const x = 470 + i * 28;
          const yc = 390;
          return <path key={i} d={`M ${x},${yc} Q ${x+8},${yc-20} ${x+14},${yc} Q ${x+20},${yc+20} ${x+28},${yc}`} fill="none" stroke="#27ae60" strokeWidth="2.5"/>;
        })}
        <text x={582} y={365} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">kᵣ</text>

        {/* Disk */}
        {(() => {
          const cx = 730, cy = 390, r = 62;
          const rd = (deg) => deg * Math.PI / 180;
          return (
            <g>
              <circle cx={cx} cy={cy} r={r} fill="#e07b00" stroke="#b7510a" strokeWidth="2.5"/>
              {[0,60,120,180,240,300].map(deg => (
                <line key={deg} x1={cx} y1={cy} x2={cx+(r-8)*Math.cos(rd(deg))} y2={cy+(r-8)*Math.sin(rd(deg))} stroke="#b7510a" strokeWidth="1.5" opacity="0.45"/>
              ))}
              <circle cx={cx} cy={cy} r={10} fill="#fff" stroke="#b7510a" strokeWidth="2"/>
              <text x={cx} y={cy+5} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">J</text>
              {/* Connect spring to disk */}
              <line x1={582} y1={390} x2={cx-r} y2={cy} stroke="#27ae60" strokeWidth="2"/>
              {/* Torque arc */}
              <path d={`M ${cx+r-6},${cy-28} A ${r} ${r} 0 0 1 ${cx+28},${cy-r+6}`} fill="none" stroke="#c0392b" strokeWidth="3"/>
              <polygon points={`${cx+22},${cy-r+16} ${cx+32},${cy-r} ${cx+40},${cy-r+12}`} fill="#c0392b"/>
              <text x={cx+44} y={cy-r+10} fontSize="14" fill="#c0392b" fontWeight="700">τ</text>
              {/* θ marker */}
              <line x1={cx} y1={cy} x2={cx} y2={cy-r+4} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4"/>
              <line x1={cx} y1={cy} x2={cx+r*Math.cos(rd(-32))} y2={cy+r*Math.sin(rd(-32))} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4"/>
              <path d={`M ${cx},${cy-26} A 26 26 0 0 1 ${cx+26*Math.cos(rd(58))},${cy-26*Math.sin(rd(58))}`} fill="none" stroke="#2E75B6" strokeWidth="1.5"/>
              <text x={cx+16} y={cy-18} fontSize="13" fill="#2E75B6" fontWeight="700">θ</text>
            </g>
          );
        })()}

        {/* EOM */}
        <text x={670} y={468} textAnchor="middle" fontSize="12" fill="#555" fontFamily="'Courier New',monospace">Jθ̈ + cᵣθ̇ + kᵣθ = τ</text>
      </svg>
      <div style={S.dCaption}>
        Mechanical systems split into translational (linear motion) and rotational (angular motion) domains. The governing equations are perfectly analogous: mass ↔ moment of inertia, force ↔ torque, displacement ↔ angle. Every formula in one domain has a direct counterpart in the other.
      </div>
    </div>
  );
}

// ── Diagram 4: Damping Regimes ────────────────────────────────────
function DiagramDampingRegimes() {
  const W = 900, H = 340;

  // Compute step responses for each regime
  // Parameters: underdamped ζ=0.2, critically damped ζ=1.0, overdamped ζ=2.0
  // x(t) for unit step: x_ss = 1
  const dt = 0.05, tMax = 10, ωn = 2;
  const underdamped = [], critical = [], overdamped = [];
  for (let t = 0; t <= tMax; t += dt) {
    const ζu = 0.2, ωdu = ωn*Math.sqrt(1-ζu*ζu);
    const xu = 1 - Math.exp(-ζu*ωn*t)*(Math.cos(ωdu*t) + (ζu/Math.sqrt(1-ζu*ζu))*Math.sin(ωdu*t));
    const xc = 1 - Math.exp(-ωn*t)*(1 + ωn*t);
    const ζo = 2.0, s1 = -ωn*(ζo - Math.sqrt(ζo*ζo-1)), s2 = -ωn*(ζo + Math.sqrt(ζo*ζo-1));
    const A = s2/(s2-s1), B = -s1/(s2-s1);
    const xo = 1 - A*Math.exp(s1*t) - B*Math.exp(s2*t);
    underdamped.push([t, xu]);
    critical.push([t, xc]);
    overdamped.push([t, xo]);
  }

  // Map to SVG coords: x:[0,10]→[50,580], y:[0,1.5]→[290,50]
  const mx = t => 50 + (t/tMax)*530;
  const my = y => 290 - (y/1.5)*240;

  const toPath = arr => arr.map(([t,y],i) => `${i===0?'M':'L'}${mx(t).toFixed(1)},${my(y).toFixed(1)}`).join(' ');

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Step Response — Damping Regimes of the MSD System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Graph area */}
        <rect x={45} y={45} width={535} height={250} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid lines */}
        {[0,0.5,1.0,1.5].map(v => (
          <g key={v}>
            <line x1={45} y1={my(v)} x2={580} y2={my(v)} stroke="#e0e0e0" strokeWidth="1"/>
            <text x={38} y={my(v)+4} textAnchor="end" fontSize="11" fill="#888">{v}</text>
          </g>
        ))}
        {[0,2,4,6,8,10].map(t => (
          <g key={t}>
            <line x1={mx(t)} y1={45} x2={mx(t)} y2={295} stroke="#e0e0e0" strokeWidth="1"/>
            <text x={mx(t)} y={310} textAnchor="middle" fontSize="11" fill="#888">{t}</text>
          </g>
        ))}

        {/* Steady-state line */}
        <line x1={45} y1={my(1)} x2={580} y2={my(1)} stroke="#999" strokeWidth="1.5" strokeDasharray="6,3"/>
        <text x={585} y={my(1)+4} fontSize="12" fill="#999" fontStyle="italic">x=1</text>

        {/* Curves */}
        <path d={toPath(underdamped)} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        <path d={toPath(critical)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <path d={toPath(overdamped)} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>

        {/* Axes */}
        <line x1={45} y1={45} x2={45} y2={295} stroke="#555" strokeWidth="2"/>
        <line x1={45} y1={295} x2={580} y2={295} stroke="#555" strokeWidth="2"/>
        <text x={315} y={330} textAnchor="middle" fontSize="13" fill="#555">Time (s)</text>
        <text x={18} y={175} textAnchor="middle" fontSize="13" fill="#555" transform="rotate(-90 18 175)">Displacement x(t)</text>

        {/* Legend */}
        <rect x={600} y={50} width={290} height={H-60} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={745} y={74} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Damping Regimes</text>

        {[
          { y:88, color:"#c0392b", label:"Underdamped  (ζ < 1)", lines:["Oscillates before settling","ζ = 0.2 shown above","Fast but overshoots setpoint","Common in: car suspensions,","control systems"] },
          { y:188, color:"#27ae60", label:"Critically Damped  (ζ = 1)", lines:["Fastest return, no overshoot","c = 2√(km) — exact threshold","Ideal for precision instruments","Used in: door closers, scales"] },
          { y:288, color:"#2E75B6", label:"Overdamped  (ζ > 1)", lines:["Slow approach to equilibrium","ζ = 2.0 shown above","No oscillation; sluggish","Used in: shock absorbers,","heavy damping applications"] },
        ].map(({ y, color, label, lines }) => (
          <g key={y}>
            <line x1={608} y1={y+8} x2={636} y2={y+8} stroke={color} strokeWidth="3"/>
            <text x={642} y={y+12} fontSize="12" fill={color} fontWeight="700">{label}</text>
            {lines.map((l, i) => <text key={i} x={642} y={y+27+i*15} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The damping ratio ζ = c / (2√(km)) determines the character of the system's response. Underdamped (ζ &lt; 1): oscillates and overshoots. Critically damped (ζ = 1): fastest non-oscillatory response. Overdamped (ζ &gt; 1): slow and sluggish. The natural frequency ωₙ = √(k/m) sets the timescale.
      </div>
    </div>
  );
}

// ── Diagram 5: Free Body Diagrams — Multi-DOF and Series Systems ────
function DiagramSeriesParallel() {
  const W = 900, H = 300;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Series vs Parallel Spring-Damper Combinations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* ── Left: Series springs ─────────────────────────────── */}
        <rect x={10} y={10} width={420} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={220} y={32} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Springs in Series</text>

        {/* Wall */}
        <rect x={18} y={60} width={12} height={180} fill="#888"/>
        {[60,80,100,120,140,160,180,200,220,240].map(y=>(
          <line key={y} x1={18} y1={y} x2={6} y2={y+18} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring 1 */}
        {(() => {
          const x0=30, x1=160, y=150, n=7, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-16]);pts.push([x0+i*cW+cW*.75,y+16]);}
          pts.push([x1,y]);
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#27ae60" strokeWidth="2.5"/>;
        })()}
        <text x={95} y={132} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">k₁</text>

        {/* Spring 2 */}
        {(() => {
          const x0=160, x1=290, y=150, n=7, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-16]);pts.push([x0+i*cW+cW*.75,y+16]);}
          pts.push([x1,y]);
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2.5"/>;
        })()}
        <text x={225} y={132} textAnchor="middle" fontSize="14" fill="#e07b00" fontWeight="700">k₂</text>

        {/* Block */}
        <rect x={290} y={120} width={60} height={60} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={320} y={155} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m</text>

        {/* Force */}
        <line x1={350} y1={150} x2={400} y2={150} stroke="#c0392b" strokeWidth="3"/>
        <polygon points="400,144 412,150 400,156" fill="#c0392b"/>
        <text x={416} y={155} fontSize="14" fill="#c0392b" fontWeight="700">F</text>

        {/* Formula */}
        <rect x={16} y={242} width={408} height={50} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={22} y={260} fontSize="13" fill="#7B0D0D" fontWeight="700">Equivalent stiffness (series):</text>
        <text x={22} y={278} fontSize="12" fill="#444" fontFamily="'Courier New',monospace">1/k_eq = 1/k₁ + 1/k₂   →   k_eq = k₁k₂/(k₁+k₂)</text>
        <text x={22} y={293} fontSize="11" fill="#555">Series springs are softer than either alone</text>

        {/* ── Right: Parallel springs ──────────────────────────── */}
        <rect x={440} y={10} width={450} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={665} y={32} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700">Springs in Parallel</text>

        {/* Wall */}
        <rect x={448} y={60} width={12} height={180} fill="#888"/>
        {[60,80,100,120,140,160,180,200,220,240].map(y=>(
          <line key={y} x1={448} y1={y} x2={436} y2={y+18} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring 1 top */}
        {(() => {
          const x0=460, x1=650, y=115, n=9, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-14]);pts.push([x0+i*cW+cW*.75,y+14]);}
          pts.push([x1,y]);
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#27ae60" strokeWidth="2.5"/>;
        })()}
        <text x={555} y={100} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">k₁</text>

        {/* Spring 2 bottom */}
        {(() => {
          const x0=460, x1=650, y=185, n=9, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-14]);pts.push([x0+i*cW+cW*.75,y+14]);}
          pts.push([x1,y]);
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2.5"/>;
        })()}
        <text x={555} y={210} textAnchor="middle" fontSize="14" fill="#e07b00" fontWeight="700">k₂</text>

        {/* Connecting line */}
        <line x1={460} y1={115} x2={460} y2={185} stroke="#555" strokeWidth="2"/>
        <line x1={650} y1={115} x2={650} y2={185} stroke="#555" strokeWidth="2"/>

        {/* Block */}
        <rect x={650} y={120} width={70} height={60} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={685} y={155} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m</text>

        {/* Force */}
        <line x1={720} y1={150} x2={780} y2={150} stroke="#c0392b" strokeWidth="3"/>
        <polygon points="780,144 792,150 780,156" fill="#c0392b"/>
        <text x={796} y={155} fontSize="14" fill="#c0392b" fontWeight="700">F</text>

        {/* Formula */}
        <rect x={446} y={242} width={438} height={50} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1"/>
        <text x={452} y={260} fontSize="13" fill="#7B0D0D" fontWeight="700">Equivalent stiffness (parallel):</text>
        <text x={452} y={278} fontSize="12" fill="#444" fontFamily="'Courier New',monospace">k_eq = k₁ + k₂</text>
        <text x={452} y={293} fontSize="11" fill="#555">Parallel springs are stiffer — share the load</text>
      </svg>
      <div style={S.dCaption}>
        Springs (and dampers) combine differently depending on their arrangement. In series the compliances add (system becomes more flexible); in parallel the stiffnesses add (system becomes stiffer). The same rules apply to dampers: c_eq = c₁ + c₂ in parallel; 1/c_eq = 1/c₁ + 1/c₂ in series.
      </div>
    </div>
  );
}

// ── Diagram 6: Analogies — Mechanical / Electrical / Fluid ──────────
function DiagramAnalogies() {
  const W = 900, H = 290;
  const domains = [
    { name:"Mechanical\n(Translational)", color:"#2E75B6", bg:"#eaf3ff",
      rows:[["Effort","Force F (N)"],["Flow","Velocity v (m/s)"],["Dissipator","Damper c  →  F=cv"],["Storage (flow)","Mass m  →  F=mav̇"],["Storage (effort)","Spring k  →  F=kx"],["Energy (dissip.)","P = Fv"],["EOM","mẍ+cẋ+kx=F"]] },
    { name:"Mechanical\n(Rotational)", color:"#27ae60", bg:"#f0fff4",
      rows:[["Effort","Torque τ (N·m)"],["Flow","Ang. velocity ω (rad/s)"],["Dissipator","Rot. damper cᵣ  →  τ=cᵣω"],["Storage (flow)","Inertia J  →  τ=Jω̇"],["Storage (effort)","Torsional spring kᵣ"],["Energy (dissip.)","P = τω"],["EOM","Jθ̈+cᵣθ̇+kᵣθ=τ"]] },
    { name:"Electrical", color:"#c0392b", bg:"#FEF0F0",
      rows:[["Effort","Voltage V (V)"],["Flow","Current I (A)"],["Dissipator","Resistor R  →  V=RI"],["Storage (flow)","Inductor L  →  V=LdI/dt"],["Storage (effort)","Capacitor C  →  I=CdV/dt"],["Energy (dissip.)","P = VI"],["EOM","LÏ+RΙ̇+(1/C)I=V̇"]] },
    { name:"Fluid /\nHydraulic", color:"#9b59b6", bg:"#f5d0ff",
      rows:[["Effort","Pressure P (Pa)"],["Flow","Volume flow Q (m³/s)"],["Dissipator","Fluidic resistance  →  P=RQ"],["Storage (flow)","Fluid inductance (inertance)"],["Storage (effort)","Fluid capacitance C"],["Energy (dissip.)","P_pow = P·Q"],["EOM","analogous to MSD"]] },
  ];

  const rowH = 30, hdrH = 42, colW = 215;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>System Analogies — Mechanical, Electrical & Fluid Domains</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {domains.map((d, di) => {
          const x = 10 + di * (colW + 5);
          return (
            <g key={di}>
              {/* Header */}
              <rect x={x} y={10} width={colW} height={hdrH} rx={4} fill={d.color}/>
              {d.name.split('\n').map((line, li) => (
                <text key={li} x={x+colW/2} y={28+li*16} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{line}</text>
              ))}
              {/* Rows */}
              {d.rows.map(([label, value], ri) => {
                const y = 10 + hdrH + ri*rowH;
                return (
                  <g key={ri}>
                    <rect x={x} y={y} width={colW} height={rowH} fill={ri%2===0 ? d.bg : '#fff'} stroke="#ddd" strokeWidth="0.5"/>
                    <text x={x+5} y={y+13} fontSize="10" fill="#7B0D0D" fontWeight="700">{label}</text>
                    <text x={x+5} y={y+26} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{value}</text>
                  </g>
                );
              })}
            </g>
          );
        })}
        {/* Horizontal connection arrows between columns */}
        {[1,2,3].map(i => (
          <g key={i}>
            <line x1={10+i*(colW+5)-3} y1={10+hdrH+3*rowH+15} x2={10+i*(colW+5)+2} y2={10+hdrH+3*rowH+15} stroke="#999" strokeWidth="1.5"/>
            <text x={10+i*(colW+5)-1} y={10+hdrH+3*rowH+11} fontSize="14" fill="#aaa">≡</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The concept of system analogies (or bond graphs) shows that mechanical, electrical, and fluid systems obey structurally identical equations. A mass is analogous to an inductor; a spring to a capacitor; a damper to a resistor. This lets engineers apply the same mathematical tools across all domains.
      </div>
    </div>
  );
}

// ── Diagram 7: 2-DOF System ──────────────────────────────────────
function Diagram2DOF() {
  const W = 900, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Two-Degree-of-Freedom (2-DOF) System — Coupled Masses</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arr3" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Ground */}
        <line x1={20} y1={210} x2={740} y2={210} stroke="#555" strokeWidth="2"/>
        {[20,45,70,95,120,145,170,195,220,245,270,295,320,345,370,395,420,445,470,495,520,545,570,595,620,645,670,695,720].map(x=>(
          <line key={x} x1={x} y1={210} x2={x-12} y2={228} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Wall */}
        <rect x={20} y={80} width={12} height={130} fill="#888"/>
        {[80,100,120,140,160,180,200].map(y=>(
          <line key={y} x1={20} y1={y} x2={8} y2={y+18} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Spring k1 */}
        {(() => {
          const x0=32, x1=180, y=145, n=8, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-18]);pts.push([x0+i*cW+cW*.75,y+18]);}
          pts.push([x1,y]);
          return <>
            <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
            <text x={106} y={118} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">k₁</text>
          </>;
        })()}

        {/* Damper c1 */}
        <rect x={32} y={175} width={96} height={22} rx={3} fill="#ddd" stroke="#999" strokeWidth="1.5"/>
        <rect x={34} y={177} width={92} height={18} rx={2} fill="#b3cde3" opacity="0.7"/>
        <rect x={128} y={173} width={54} height={26} rx={1} fill="#888"/>
        <text x={80} y={172} textAnchor="middle" fontSize="13" fill="#555" fontWeight="700">c₁</text>

        {/* Mass 1 */}
        <rect x={180} y={110} width={100} height={100} rx={5} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={230} y={168} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">m₁</text>
        <text x={230} y={110} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">x₁</text>
        <line x1={218} y1={104} x2={242} y2={104} stroke="#2E75B6" strokeWidth="2" strokeDasharray="3"/>

        {/* Spring k2 */}
        {(() => {
          const x0=280, x1=440, y=145, n=9, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-18]);pts.push([x0+i*cW+cW*.75,y+18]);}
          pts.push([x1,y]);
          return <>
            <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2.5"/>
            <text x={360} y={118} textAnchor="middle" fontSize="14" fill="#e07b00" fontWeight="700">k₂</text>
          </>;
        })()}

        {/* Damper c2 */}
        <rect x={280} y={175} width={96} height={22} rx={3} fill="#ddd" stroke="#999" strokeWidth="1.5"/>
        <rect x={282} y={177} width={92} height={18} rx={2} fill="#b3cde3" opacity="0.7"/>
        <rect x={376} y={173} width={66} height={26} rx={1} fill="#888"/>
        <text x={328} y={172} textAnchor="middle" fontSize="13" fill="#555" fontWeight="700">c₂</text>

        {/* Mass 2 */}
        <rect x={440} y={110} width={100} height={100} rx={5} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
        <text x={490} y={168} textAnchor="middle" fontSize="22" fill="#fff" fontWeight="700">m₂</text>
        <text x={490} y={110} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">x₂</text>
        <line x1={478} y1={104} x2={502} y2={104} stroke="#c0392b" strokeWidth="2" strokeDasharray="3"/>

        {/* Spring k3 to right wall */}
        {(() => {
          const x0=540, x1=700, y=145, n=9, cW=(x1-x0)/n;
          const pts=[[x0,y]];
          for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*.25,y-18]);pts.push([x0+i*cW+cW*.75,y+18]);}
          pts.push([x1,y]);
          return <>
            <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>
            <text x={620} y={118} textAnchor="middle" fontSize="14" fill="#9b59b6" fontWeight="700">k₃</text>
          </>;
        })()}

        {/* Right wall */}
        <rect x={700} y={80} width={12} height={130} fill="#888"/>
        {[80,100,120,140,160,180,200].map(y=>(
          <line key={y} x1={712} y1={y} x2={724} y2={y+18} stroke="#888" strokeWidth="1.5"/>
        ))}

        {/* Applied forces */}
        <line x1={230} y1={160} x2={230} y2={90} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arr3)"/>
        <text x={238} y={88} fontSize="12" fill="#c0392b" fontWeight="700">F₁(t)</text>

        <line x1={490} y1={160} x2={490} y2={90} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arr3)"/>
        <text x={498} y={88} fontSize="12" fill="#c0392b" fontWeight="700">F₂(t)</text>

        {/* EOM box */}
        <rect x={745} y={20} width={148} height={H-30} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={819} y={38} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Equations of</text>
        <text x={819} y={52} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Motion (EOM)</text>
        <line x1={752} y1={56} x2={886} y2={56} stroke="#f0cece"/>
        <text x={750} y={72} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">m₁ẍ₁ + (c₁+c₂)ẋ₁</text>
        <text x={750} y={85} fontSize="10" fill="#333" fontFamily="'Courier New',monospace"> - c₂ẋ₂ + (k₁+k₂)x₁</text>
        <text x={750} y={98} fontSize="10" fill="#333" fontFamily="'Courier New',monospace"> - k₂x₂ = F₁</text>
        <line x1={752} y1={106} x2={886} y2={106} stroke="#f0cece"/>
        <text x={750} y={120} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">m₂ẍ₂ + (c₂+c₃)ẋ₂</text>
        <text x={750} y={133} fontSize="10" fill="#333" fontFamily="'Courier New',monospace"> - c₂ẋ₁ + (k₂+k₃)x₂</text>
        <text x={750} y={146} fontSize="10" fill="#333" fontFamily="'Courier New',monospace"> - k₂x₁ = F₂</text>
        <line x1={752} y1={154} x2={886} y2={154} stroke="#f0cece"/>
        <text x={750} y={170} fontSize="10" fill="#7B0D0D" fontWeight="700">Matrix form:</text>
        <text x={750} y={183} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">[M]ẍ + [C]ẋ</text>
        <text x={750} y={196} fontSize="10" fill="#333" fontFamily="'Courier New',monospace"> + [K]x = F</text>
        <line x1={752} y1={203} x2={886} y2={203} stroke="#f0cece"/>
        <text x={750} y={217} fontSize="10" fill="#555">2 natural frequencies</text>
        <text x={750} y={230} fontSize="10" fill="#555">2 mode shapes</text>
        <text x={750} y={243} fontSize="10" fill="#555">n-DOF → n modes</text>
      </svg>
      <div style={S.dCaption}>
        A 2-DOF system has two coupled equations of motion, written compactly as [M]ẍ + [C]ẋ + [K]x = F using mass, damping, and stiffness matrices. The system has two natural frequencies and two corresponding mode shapes. Real structures are multi-DOF systems solved by modal analysis.
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────
export default function SystemDynamics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Elementary Parts &amp; Mechanical Components — System Dynamics</h1>
      <p style={S.p}>
        System dynamics in mechanics is the study of how physical systems move, vibrate, and respond to forces over time. Every mechanical system, however complex — from a car suspension to a skyscraper in an earthquake — can be modelled by assembling just three elementary components: <strong>mass</strong>, <strong>spring</strong>, and <strong>damper</strong>. Understanding these building blocks, their governing laws, and how they combine is the foundation of structural analysis, vibration engineering, and control systems.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Three elementary elements: Mass (m) stores kinetic energy; Spring (k) stores potential energy; Damper (c) dissipates energy",
        "Newton's 2nd Law applied to a free body diagram gives the Equation of Motion: mẍ + cẋ + kx = F(t)",
        "Natural frequency: ωₙ = √(k/m) — the frequency at which the system oscillates freely",
        "Damping ratio: ζ = c/(2√km) — determines whether response oscillates (ζ<1), is critical (ζ=1), or sluggish (ζ>1)",
        "Translational and rotational systems are perfectly analogous: F↔τ, m↔J, x↔θ, v↔ω",
        "Springs in series: 1/k_eq = 1/k₁ + 1/k₂   |   Springs in parallel: k_eq = k₁ + k₂",
        "Multi-DOF systems have multiple natural frequencies and mode shapes — solved using matrix methods",
        "Mechanical, electrical, and fluid systems share identical mathematical structure (system analogies)",
      ]}/>

      <h2 style={S.h2}>The Three Elementary Mechanical Elements</h2>
      <p style={S.p}>
        All mechanical dynamic systems are built from three primitive components. Each has a distinct physical role, a characteristic constitutive law relating force to motion, and an energy behaviour. Mastering these three elements — and their governing equations — unlocks the analysis of any mechanical system.
      </p>
      <DiagramThreeElements/>
      <Table2 rows={[
        ["Mass (m)","F = m·ẍ   (Newton's Second Law)\nStores kinetic energy: T = ½mv²\nResists acceleration — inertia element; never dissipates energy"],
        ["Spring (k)","F = k·x   (Hooke's Law)\nStores potential energy: V = ½kx²\nRestoring force — proportional to displacement from equilibrium"],
        ["Viscous Damper (c)","F = c·ẋ = c·v   (dashpot / viscous friction)\nDissipates energy as heat: P = cv²\nForce proportional to velocity; no energy storage"],
        ["Coulomb (dry) friction","F = μₖ·N · sign(ẋ)   (constant magnitude, direction opposes motion)\nNon-linear; cannot be modelled as a linear dashpot\nLeads to stick-slip behaviour"],
        ["Structural (hysteretic) damping","Complex stiffness: k* = k(1 + iη)\nη = loss factor; energy loss per cycle proportional to amplitude²\nCommon in metals and composites"],
      ]}/>

      <h2 style={S.h2}>The Mass-Spring-Damper System</h2>
      <p style={S.p}>
        The single-degree-of-freedom (SDOF) mass-spring-damper system is the canonical model of mechanical dynamics. Applying Newton's second law to the free body diagram of the mass yields a second-order linear ODE. Its solution describes everything from building sway in wind to the bounce of a vehicle suspension.
      </p>
      <DiagramMSD/>
      <Table2 rows={[
        ["Equation of Motion","mẍ + cẋ + kx = F(t)\nInertia term + Damping term + Stiffness term = Applied force"],
        ["Free undamped vibration","mẍ + kx = 0   →   x(t) = A cos(ωₙt) + B sin(ωₙt)\nωₙ = √(k/m)   (rad/s); fₙ = ωₙ/(2π)   (Hz)"],
        ["Natural frequency ωₙ","ωₙ = √(k/m)\nIncreases with stiffness; decreases with mass\nDoubling k raises ωₙ by factor √2"],
        ["Critical damping cc","cc = 2√(km) = 2mωₙ\nMinimum damping to prevent oscillation"],
        ["Damping ratio ζ","ζ = c / cc = c / (2mωₙ)\nDimensionless; classifies response character"],
        ["Damped natural frequency","ωd = ωₙ√(1 − ζ²)\nFrequency of actual oscillation in underdamped system\nApproaches ωₙ as ζ → 0"],
        ["Resonance","Occurs when forcing frequency ω = ωₙ\nIn undamped system: amplitude → ∞; damping limits the peak\nAmplification factor at resonance: Q = 1/(2ζ)"],
        ["Static deflection","xst = F₀/k   (deflection under constant load F₀)\nLinks static stiffness to natural frequency: ωₙ = √(g/xst)"],
      ]}/>

      <h2 style={S.h2}>Free Response — Damping Regimes</h2>
      <p style={S.p}>
        When the system is released from an initial displacement (no applied force), its behaviour depends entirely on the damping ratio ζ. The three regimes — underdamped, critically damped, and overdamped — have qualitatively different step responses and are chosen deliberately in engineering design.
      </p>
      <DiagramDampingRegimes/>
      <Table2 rows={[
        ["Underdamped  (ζ < 1)","x(t) = e^{−ζωₙt}[A cos(ωd t) + B sin(ωd t)]\nOscillates with decaying amplitude; envelope decays as e^{−ζωₙt}\nUsed where fast response is needed and some overshoot is acceptable"],
        ["Critically damped  (ζ = 1)","x(t) = (A + Bt) e^{−ωₙt}\nFastest return to equilibrium without overshoot\nIdeal for instruments, door closers, galvanometers"],
        ["Overdamped  (ζ > 1)","x(t) = A e^{s₁t} + B e^{s₂t}   (s₁,s₂ real, negative)\nNo oscillation; sluggish approach to equilibrium\nUsed when overshoot must be absolutely avoided"],
        ["Logarithmic decrement δ","δ = ln(xₙ/xₙ₊₁) = 2πζ/√(1−ζ²)\nExperimentally measure successive peaks to find ζ\nSimple test: drop system, record free decay"],
        ["Quality factor Q","Q = ωₙ/Δω = 1/(2ζ)\nRatio of resonant frequency to bandwidth\nHigh Q = lightly damped, sharp resonance"],
      ]}/>

      <h2 style={S.h2}>Translational vs Rotational Systems</h2>
      <p style={S.p}>
        Mechanical systems can involve linear (translational) or angular (rotational) motion. The equations of motion in both cases are structurally identical — every translational quantity has a rotational counterpart. This perfect analogy allows the same solution methods to be applied across both domains.
      </p>
      <DiagramFBD/>
      <Table2 rows={[
        ["Moment of Inertia J","Rotational analogue of mass\nJ = Σmᵢrᵢ² or ∫r² dm   (depends on geometry)\nCylinder about axis: J = ½mR²; thin rod: J = mL²/12"],
        ["Torsional spring kᵣ","τ = kᵣ·θ\nRestores against angular displacement; units: N·m/rad\nExample: drive shaft, rubber coupling"],
        ["Rotational damper cᵣ","τ = cᵣ·θ̇\nResists angular velocity; units: N·m·s/rad\nViscous fluid bearings, electromagnetic braking"],
        ["Rotational EOM","Jθ̈ + cᵣθ̇ + kᵣθ = τ(t)\nDirect analogue of mẍ + cẋ + kx = F(t)"],
        ["Angular natural frequency","ωₙ = √(kᵣ/J)\nSame form as translational: substitute J for m, kᵣ for k"],
        ["Gear pairs","Gear ratio n = ω₂/ω₁ = T₁/T₂ = N₁/N₂\nReflected inertia: J_reflected = J₂/n²  (reduces inertia by gear ratio²)"],
        ["Pinion and rack","Converts rotation to translation: v = r·ω, F = τ/r\nUsed in steering systems, linear actuators"],
      ]}/>

      <h2 style={S.h2}>Combining Springs and Dampers</h2>
      <p style={S.p}>
        Real systems often use multiple springs and dampers arranged in series or parallel. The equivalent stiffness or damping coefficient of the combination determines the effective single-element that replaces them in the model.
      </p>
      <DiagramSeriesParallel/>
      <Table2 rows={[
        ["Springs in series","1/k_eq = 1/k₁ + 1/k₂ + … + 1/kₙ\nEquivalent spring softer than softest member\nSame force through each spring; displacements add"],
        ["Springs in parallel","k_eq = k₁ + k₂ + … + kₙ\nEquivalent spring stiffer than stiffest member\nSame displacement; forces add"],
        ["Dampers in series","1/c_eq = 1/c₁ + 1/c₂  (same rules as springs)\nUsed in model of viscoelastic materials"],
        ["Dampers in parallel","c_eq = c₁ + c₂\nCommon in multi-path vibration isolation"],
        ["Kelvin-Voigt model","Spring ‖ Damper in parallel\nViscoelastic solid: kε + cε̇ = σ (stress/strain)\nUsed for polymers, rubber mounts"],
        ["Maxwell model","Spring — Damper in series\nViscoelastic fluid: stress relaxes over time\nGood for asphalt, biological tissues"],
        ["Zener (Standard Linear Solid)","Spring in series with Kelvin-Voigt element\nCaptures both creep and stress relaxation\nBest simple model for real elastomers"],
      ]}/>

      <h2 style={S.h2}>System Analogies — Unified Framework</h2>
      <p style={S.p}>
        One of the most powerful concepts in system dynamics is that mechanical, electrical, and fluid systems all obey structurally identical governing equations. This means solutions, intuitions, and simulation tools developed in one domain transfer directly to all others — and lets engineers use electrical circuit theory to solve mechanical problems (and vice versa).
      </p>
      <DiagramAnalogies/>
      <Table2 rows={[
        ["Force–Voltage analogy","F ↔ V, v ↔ I, m ↔ L, k ↔ 1/C, c ↔ R\nKirchhoff's voltage law ↔ Newton's second law\nInductance stores kinetic energy; capacitance stores potential energy"],
        ["Force–Current analogy","F ↔ I, v ↔ V, m ↔ C, k ↔ 1/L, c ↔ 1/R\n(Admittance analogy — preferred for network synthesis)"],
        ["Bond graph method","Generalised framework using power bonds (effort × flow = power)\nWorks for any energy domain on a single diagram\nUsed in complex multi-domain systems (mechatronics, thermofluids)"],
        ["Impedance Z","Z = F/v  (mechanical)   or   Z = V/I  (electrical)\nAt a forcing frequency ω: Zmech = c + j(mω − k/ω)\nSame form as electrical R + jX"],
      ]}/>

      <h2 style={S.h2}>Multi-Degree-of-Freedom (MDOF) Systems</h2>
      <p style={S.p}>
        When a system has more than one independent coordinate needed to describe its motion, it is a multi-DOF system. Each degree of freedom introduces one additional natural frequency and one mode shape. Real structures — bridges, aircraft, buildings — are continuous (infinite-DOF) systems approximated numerically by finite element methods.
      </p>
      <Diagram2DOF/>
      <Table2 rows={[
        ["Degrees of freedom (DOF)","Number of independent coordinates needed to fully describe motion\nA rigid body in 3D space has 6 DOF (3 translational, 3 rotational)"],
        ["Mass matrix [M]","n×n diagonal matrix of masses/inertias\n[M]ᵢᵢ = mᵢ; off-diagonal terms zero for lumped masses"],
        ["Stiffness matrix [K]","n×n symmetric matrix; [K]ᵢⱼ = stiffness coupling DOFs i and j\nAssembled from element stiffness matrices in FEA"],
        ["Damping matrix [C]","n×n; often approximated as proportional: [C] = α[M] + β[K]\n(Rayleigh damping — preserves modal decoupling)"],
        ["Eigenvalue problem","([K] − ω²[M]){Φ} = 0\nSolves for n natural frequencies ωᵢ and mode shapes {Φᵢ}"],
        ["Modal analysis","Transform to modal coordinates; each mode decouples to SDOF\nSolution superimposed: x = Σ φᵢ qᵢ(t)"],
        ["Dynamic stiffness","K_dyn = K − ω²M + jωC\nFrequency-dependent; used for frequency response functions (FRF)"],
        ["Vibration isolation","Mount mass on soft spring: f_isolation = ωₙ/(2π) ≪ forcing frequency\nTransmissibility T = √[(1+(2ζr)²)/((1-r²)²+(2ζr)²)], r = ω/ωₙ"],
      ]}/>

      <h2 style={S.h2}>Forced Response &amp; Resonance</h2>
      <p style={S.p}>
        When a periodic force is applied, the system reaches a steady-state oscillation at the forcing frequency. The amplitude and phase depend on how close the forcing frequency is to the natural frequency and on the damping present. Near resonance, even small forces can produce large, potentially destructive responses.
      </p>
      <Table2 rows={[
        ["Steady-state amplitude","X = (F₀/k) / √[(1−r²)² + (2ζr)²]\nr = ω/ωₙ  (frequency ratio); F₀ = force amplitude"],
        ["Dynamic amplification D","D = X / (F₀/k) = 1/√[(1−r²)² + (2ζr)²]\nD = 1 at ω = 0; D → ∞ as r → 1, ζ → 0"],
        ["Phase angle φ","tan φ = 2ζr / (1 − r²)\nResponse lags force; at resonance φ = 90° regardless of ζ"],
        ["Resonance condition","ω = ωₙ√(1 − 2ζ²)  (amplitude peak)\nFor small ζ, effectively ω ≈ ωₙ"],
        ["Base excitation","Transmissibility T = force transmitted to base / applied force\nT < 1 only for r > √2 — isolation requires soft mounts"],
        ["Rotating unbalance","F₀ = m·e·ω²  (e = eccentricity, m = unbalanced mass)\nCommon source of vibration in motors, fans, turbines"],
        ["Beating","Two close frequencies ω₁ ≈ ω₂: amplitude modulated at |ω₁−ω₂|\nAppears to 'beat' in/out of phase — dangerous near resonance"],
      ]}/>

      <h2 style={S.h2}>Energy Methods — Lagrangian Dynamics</h2>
      <p style={S.p}>
        Rather than drawing free-body diagrams and summing forces, Lagrangian mechanics derives equations of motion from energy expressions alone. This approach is especially powerful for complex multi-DOF or constrained systems where Newton's vector approach becomes unwieldy.
      </p>
      <Table2 rows={[
        ["Lagrangian L","L = T − V   (kinetic minus potential energy)\nFunction of generalised coordinates qᵢ and velocities q̇ᵢ"],
        ["Euler-Lagrange equation","d/dt(∂L/∂q̇ᵢ) − ∂L/∂qᵢ = Qᵢ\nQᵢ = generalised non-conservative force (e.g. damping, applied force)"],
        ["Generalised coordinates","Any independent set of coordinates describing configuration\nCan be angles, displacements, or combinations — no need for Cartesian axes"],
        ["Virtual work","δW = Σ Fᵢ · δqᵢ\nEliminates constraint forces; only applied forces appear"],
        ["Rayleigh dissipation function","D = ½Σ cᵢⱼ q̇ᵢ q̇ⱼ\nAdds damping into Lagrangian framework: Euler-Lagrange becomes\nd/dt(∂L/∂q̇) − ∂L/∂q + ∂D/∂q̇ = Q"],
        ["Hamilton's principle","δ∫(T−V)dt + ∫δW_nc dt = 0\nVariational formulation; basis for FEA shape functions"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Equation of Motion (SDOF):  mẍ + cẋ + kx = F(t)",
        "Natural frequency:  ωₙ = √(k/m)   [rad/s]   or   fₙ = (1/2π)√(k/m)   [Hz]",
        "Damping ratio:  ζ = c / (2mωₙ) = c / (2√(km))",
        "Damped natural frequency:  ωd = ωₙ√(1 − ζ²)",
        "Rotational EOM:  Jθ̈ + cᵣθ̇ + kᵣθ = τ(t)",
        "Springs in series:  1/k_eq = 1/k₁ + 1/k₂   |   In parallel:  k_eq = k₁ + k₂",
        "Dynamic amplification:  D = 1 / √[(1−r²)² + (2ζr)²]  ,  r = ω/ωₙ",
        "Matrix EOM (MDOF):  [M]ẍ + [C]ẋ + [K]x = F(t)",
        "Euler-Lagrange:  d/dt(∂L/∂q̇ᵢ) − ∂L/∂qᵢ = Qᵢ  ,  L = T − V",
      ]}/>
    </div>
  );
}